import { render } from "./Lectura2.vue?vue&type=template&id=07eef7fd"
import script from "./Lectura2.vue?vue&type=script&lang=js"
export * from "./Lectura2.vue?vue&type=script&lang=js"

import "./Lectura2.vue?vue&type=style&index=0&id=07eef7fd&lang=css"
script.render = render

export default script